import { formatTimeDisplay } from './methods/format-time-display'
import { formatVolumeDisplay } from './methods/format-volume-display'
import { getTrendFilterItems, TREND_KEYWORD_TYPES } from './methods/get-trend-filter-items'
import { fetchTrends } from './methods/fetch-trends'

/**
 * Trend service provides methods for working with trend data
 */
export const trendsService = {
  // Constants
  TREND_KEYWORD_TYPES,
  
  // Methods
  formatTimeDisplay,
  formatVolumeDisplay,
  getTrendFilterItems,
  fetchTrends,
}

export {
  TREND_KEYWORD_TYPES,
  formatTimeDisplay,
  formatVolumeDisplay,
  getTrendFilterItems,
  fetchTrends,
}
